import { Menu, X } from "lucide-react";
import { colors } from "./colors";

export function LandingHeader({ mobileMenuOpen, setMobileMenuOpen, scrollToSection }) {
  return (
    <>
      {/* Sticky Header */}
      <nav
        className="fixed top-0 left-0 right-0 z-50"
        data-testid="landing-header"
        style={{
          backgroundColor: "#ffffff",
          height: "88px",
        }}
      >
        <div
          className="h-full max-w-7xl mx-auto flex items-center justify-between px-6 md:px-12"
        >
          <a href="/" className="flex items-center h-full" data-testid="landing-logo-link">
            <img
              src="https://customer-assets.emergentagent.com/job_8871d808-9ccd-4157-8de6-34b5e308c5cc/artifacts/vzg0ky1i_tgaone_black.png.png"
              alt="TGAone"
              style={{ height: "72px", width: "auto" }}
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center h-full" style={{ gap: "56px" }}>
            {[
              { label: "Leistungen", id: "leistungen" },
              { label: "Projekte", id: "projekte" },
              { label: "Kontakt", id: "kontakt" },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="relative h-full flex items-center group"
                data-testid={`nav-${item.id}`}
                style={{
                  color: "#1A1A1A",
                  fontWeight: 500,
                  fontSize: "15px",
                  letterSpacing: "0.01em",
                }}
              >
                {item.label}
                <span
                  className="absolute bottom-6 left-0 w-0 h-px group-hover:w-full transition-all duration-300"
                  style={{ backgroundColor: "#1A1A1A" }}
                />
              </button>
            ))}
            <a
              href="/partnerlogin"
              className="relative h-full flex items-center group"
              data-testid="landing-partnerlogin-link"
              style={{
                color: "#1A1A1A",
                fontWeight: 600,
                fontSize: "15px",
                letterSpacing: "0.01em",
                paddingLeft: "20px",
                marginLeft: "12px",
                borderLeft: "1px solid #d4d4d4",
              }}
            >
              HPS Anlagencheck Login
              <span className="absolute bottom-6 left-5 w-0 h-px group-hover:w-[calc(100%-1.25rem)] transition-all duration-300" style={{ backgroundColor: "#2563eb" }} />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(true)}
            className="lg:hidden p-2"
            style={{ color: "#1A1A1A" }}
            aria-label="Menü"
            data-testid="mobile-menu-button"
          >
            <Menu className="w-6 h-6" />
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-black/80 z-[60] transition-opacity duration-300 lg:hidden ${
          mobileMenuOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setMobileMenuOpen(false)}
      />

      {/* Mobile Menu Panel */}
      <div
        className={`fixed top-0 right-0 h-full w-72 max-w-[85vw] z-[70] transform transition-transform duration-300 lg:hidden ${
          mobileMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ backgroundColor: colors.anthracite }}
        data-testid="mobile-menu-panel"
      >
        <div className="flex items-center justify-between p-6 border-b border-white/10">
          <span className="text-white/50 text-xs uppercase tracking-widest">Menü</span>
          <button
            onClick={() => setMobileMenuOpen(false)}
            className="text-white/70 hover:text-white"
            data-testid="mobile-menu-close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <nav className="p-6 space-y-2">
          {[
            { label: "Leistungen", action: () => scrollToSection("leistungen") },
            { label: "Projekte", action: () => scrollToSection("projekte") },
            { label: "Kontakt", action: () => scrollToSection("kontakt") },
          ].map((item) => (
            <button
              key={item.label}
              onClick={item.action}
              className="block w-full text-left py-3 px-4 text-white/80 hover:text-white hover:bg-white/5 rounded transition-colors"
            >
              {item.label}
            </button>
          ))}
          <a
            href="/partnerlogin"
            className="block py-3 px-4 mt-3 text-white font-medium rounded transition-colors"
            style={{ background: "linear-gradient(135deg,#4a9eff,#2563eb)" }}
            data-testid="mobile-partnerlogin-link"
          >
            HPS Anlagencheck Login
          </a>
        </nav>
      </div>
    </>
  );
}
